<script setup>
import GeneralLink from 'multisite/components/cmsContentBlocks/generalLink.vue';
import { reactive, computed } from 'vue';

const props = defineProps({
	url: String,
	vm: Object,
	variant: Object,
});

const linkSettings = reactive({
	LinkTarget: props.vm.BaseViewModel.LinkTarget,
	LinkBehavior: props.vm.BaseViewModel.LinkBehavior,
	LinkLabel: props.vm.BaseViewModel.Text,
	Language: props.vm.BaseViewModel.Language,
});

const icon = computed(() => {
	if (props.vm.BaseViewModel.IconEnd) {
		return props.vm.BaseViewModel.IconEnd
	} else {
		return props.vm.BaseViewModel.Variant === "link" || props.vm.BaseViewModel.Variant === "link-neutral" ? "button-navigate-forward" : "";
	}
});
</script>

<template>
	<GeneralLink
		:link-settings="linkSettings"
		:url="url"
		:variant="variant.BaseViewModel"
		:icon-end="icon"
		:icon-start="props.vm.BaseViewModel.IconStart"
		:button-variant="props.vm.BaseViewModel.Variant"
		>
		<slot></slot>
	</GeneralLink>
</template>
